"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var UserResource = /** @class */ (function (_super) {
    tslib_1.__extends(UserResource, _super);
    function UserResource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.permissions = null;
        return _this;
    }
    UserResource.prototype.retrievePermissions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var endpoint, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.wrap('/permissions');
                        return [4 /*yield*/, endpoint.get()];
                    case 1:
                        response = _a.sent();
                        this.permissions = response.data;
                        return [2 /*return*/, this.permissions];
                }
            });
        });
    };
    UserResource.prototype.isStaff = function () {
        return this.attributes.is_staff;
    };
    UserResource.prototype.isSuperuser = function () {
        return this.attributes.is_superuser;
    };
    /**
     * Check each argument (as a permission name) exists
     */
    UserResource.prototype.hasPermissionAny = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.isSuperuser()) {
            return true;
        }
        if (this.permissions === null) {
            throw new Error('Permissions have not been retrieved');
        }
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var perm = args_1[_a];
            if (this.permissions.includes(perm)) {
                return true;
            }
        }
        return false;
    };
    UserResource.prototype.hasPermissionAll = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.isSuperuser()) {
            return true;
        }
        if (this.permissions === null) {
            throw new Error('Permissions have not been retrieved');
        }
        for (var _a = 0, args_2 = args; _a < args_2.length; _a++) {
            var perm = args_2[_a];
            if (!this.permissions.includes(perm)) {
                return false;
            }
        }
        return true;
    };
    UserResource.prototype.hasScopeAny = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var scopes = args.map(function (arg) { return "auth.has_scope_" + arg; });
        return this.hasPermissionAny.apply(this, scopes);
    };
    UserResource.prototype.hasScopeAll = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var scopes = args.map(function (arg) { return "auth.has_scope_" + arg; });
        return this.hasPermissionAll.apply(this, scopes);
    };
    UserResource.prototype.toString = function () {
        return this.attributes.first_name || this.attributes.username;
    };
    UserResource.endpoint = '/users';
    UserResource.MODEL_NAME = 'user';
    return UserResource;
}(base_1.default));
exports.default = UserResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/user/index.js
// module id = bENM
// module chunks = 0